<template>
    <common-modal v-if="isOpen" width="medium" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <common-page-header
                :heading="$t('pages.referrals-pool.index.confirm_slots_modal.heading')"
                :content="$t('pages.referrals-pool.index.confirm_slots_modal.content')"
                :isCenter="true"
                contentSpacing="medium"
                contentColor="secondary"
            ></common-page-header>

            <common-content-wrapper width="base">
                <common-content-spacer height="small">
                    <referral-time-slots-preview
                        :groupSlotsByDate="selectedSlotsByDate"
                        :showDeleteIcon="false"
                        class="confirm-slots-modal__time-slots-preview"
                    ></referral-time-slots-preview>

                    <common-buttons class="modal-buttons">
                        <common-button
                            :label="$t('pages.referrals-pool.index.confirm_slots_modal.buttons.go_back')"
                            type="secondary"
                            :isDisabled="isProcessing"
                            @click="emitEvent({ name: 'close' })"
                        ></common-button>
                        <common-button
                            :label="$t('pages.referrals-pool.index.confirm_slots_modal.buttons.confirm_submit')"
                            type="primary"
                            :isProcessing="isProcessing"
                            @click="confirmSubmit"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </common-content-wrapper>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import ReferralTimeSlotsPreview from 'components/page-elements/referrals/ReferralTimeSlotsPreview.vue'

    export default {
        mixins: [FormMixin],

        components: {
            ReferralTimeSlotsPreview,
        },

        props: {
            isOpen: { type: Boolean, required: true },
            selectedSlotsByDate: { type: Object, required: true },
            isProcessing: { type: Boolean, default: false },
        },

        methods: {
            confirmSubmit() {
                this.emitEvent({ name: 'confirm' })
            },
        },
    }
</script>

<style scoped lang="scss">
    .modal-buttons {
        margin-top: 24px;
        display: flex;
        gap: 12px;
        justify-content: center;
    }

    .confirm-slots-modal__time-slots-preview {
        justify-content: center;
        display: grid;
    }
</style>
